/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'WORKERS_USE_FALL_PROTECTION_WHEN_NEEDED',
              'FALL_PROTECTION_EQUIPMENT_IS_IN_GOOD_CONDITION',
              'FALL_PROTECTION_EQUIPMENT_IS_STORED_PROPERLY_IN_A_DESIGNATED_LO',
              'WORKERS_ARE_TRAINED_ON_THE_PROPER_USE_OF_FALL_PROTECTION_EQUIPM',
              'HIGH_WORKING_AREAS_HAVE_WALLS_FENCES_OR_OTHER_BARRIERS_OR_WORKE',
              'NOT_APPLICABLE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place: valueSchema,
  },
}
